var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1107_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.0999C0 24.8809 7.16324 31.999 15.9998 31.999C24.8363 31.999 32 24.8809 32 16.0999C32 7.31897 24.8363 0.200775 15.9998 0.200775C7.16324 0.200775 0 7.31897 0 16.0999Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94262 12.3542L9.33757 11.1417C9.41786 10.8951 9.61372 10.7032 9.86282 10.6275L11.089 10.2528C11.2587 10.2013 11.2601 9.96335 11.0918 9.9091L9.87108 9.51662C9.62336 9.43684 9.43023 9.24221 9.35363 8.99468L8.97701 7.7762C8.92518 7.60799 8.68572 7.60618 8.63112 7.77393L8.23617 8.98647C8.15588 9.23263 7.96001 9.42455 7.71092 9.50066L6.48473 9.87492C6.31501 9.92689 6.31317 10.1644 6.48198 10.2186L7.70266 10.6111C7.95037 10.6909 8.14351 10.886 8.2201 11.1335L8.59673 12.3515C8.64856 12.5202 8.88801 12.522 8.94262 12.3542Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3236 11.6485C27.8181 11.0868 27.0293 10.7706 26.2623 10.6408C25.4892 10.5163 24.6785 10.5279 23.9153 10.6626C22.371 10.9222 20.9681 11.5576 19.7444 12.3415C19.109 12.7262 18.5671 13.1713 18.0057 13.6247C17.7352 13.8539 17.4885 14.0981 17.2317 14.3388L16.5299 15.0326C15.7673 15.8248 15.0157 16.5462 14.2884 17.1442C13.5582 17.7395 12.8755 18.1916 12.2028 18.5072C11.5304 18.8246 10.811 19.0112 9.87331 19.0411C8.94385 19.0737 7.84419 18.907 6.66793 18.6318C5.48534 18.3579 4.2435 17.9674 2.85577 17.6315C3.33999 18.9663 4.06914 20.1459 5.0053 21.2242C5.95244 22.2839 7.13513 23.2497 8.65446 23.8849C10.1518 24.5341 12.0336 24.767 13.793 24.4154C15.5572 24.0781 17.1053 23.2668 18.3566 22.3288C19.6112 21.381 20.6262 20.3013 21.4819 19.179C21.7181 18.8689 21.843 18.6953 22.014 18.4529L22.4865 17.7575C22.8148 17.3274 23.1137 16.8376 23.4386 16.4113C24.0757 15.5187 24.704 14.6272 25.4339 13.8057C25.8013 13.3891 26.1888 12.9906 26.6461 12.6076C26.8741 12.4207 27.1206 12.2378 27.3936 12.073C27.6707 11.8952 27.9633 11.7561 28.3236 11.6485Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3236 11.6485C27.7807 10.2868 26.771 9.14052 25.4159 8.29467C24.0691 7.45814 22.1985 7.03122 20.3447 7.39515C19.429 7.57113 18.5418 7.90997 17.7632 8.36121C16.9882 8.81064 16.2936 9.35166 15.6924 9.93207C15.3922 10.2232 15.1198 10.527 14.8491 10.8324L14.1476 11.7212L13.0641 13.152C11.6828 14.9927 10.1953 17.15 7.75418 17.7892C5.35777 18.4168 4.3184 17.861 2.85577 17.6314C3.12322 18.3175 3.45448 18.9838 3.90357 19.57C4.3443 20.168 4.86489 20.7298 5.5121 21.2112C5.83917 21.4424 6.18448 21.6706 6.568 21.8642C6.94979 22.0512 7.3615 22.2158 7.80095 22.3398C8.67508 22.5779 9.6592 22.6612 10.612 22.5332C11.5653 22.4068 12.4765 22.1066 13.273 21.7079C14.0754 21.313 14.7743 20.832 15.3984 20.3244C16.639 19.3006 17.604 18.1694 18.4191 17.0259C18.8291 16.4542 19.2013 15.8717 19.5455 15.2891L19.9506 14.5954C20.0745 14.3927 20.1997 14.1887 20.3269 13.9987C20.8403 13.2353 21.3424 12.6232 21.9522 12.1638C22.5535 11.6925 23.391 11.3443 24.51 11.2634C25.6243 11.1815 26.9108 11.3327 28.3236 11.6485Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2949 22.9625C22.2949 23.9626 23.1113 24.7738 24.1177 24.7738C25.1243 24.7738 25.9394 23.9626 25.9394 22.9625C25.9394 21.9623 25.1243 21.1512 24.1177 21.1512C23.1113 21.1512 22.2949 21.9623 22.2949 22.9625Z",
    fill: "#ADADAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1107_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrk);
export default __webpack_public_path__ + "static/media/STRK.2d18f5cce005c7c19342a88f9f46b740.svg";
export { ForwardRef as ReactComponent };